export default __webpack_public_path__ + "images/5f0e40893a0baa626de9bb3a2eaf3e6b-anime.jpg";